<script>
  import { createEventDispatcher } from 'svelte';
  import { broadcaster } from './broadcast-store';

  const dispatch = createEventDispatcher();

  const onCamSelected = (videoDevice) => {
    broadcaster.update((s) => ({
      ...s,
      selectedVideoDevice: videoDevice,
    }));
    dispatch('camselected', videoDevice);
  };

  const onMicSelected = (audioDevice) => {
    broadcaster.update((s) => ({
      ...s,
      selectedAudioDevice: audioDevice,
    }));
    dispatch('micselected', audioDevice);
  };
</script>

<div class="media-devices-container">
  <div class="controls">
    <div class="label">
      <span class="material-icons"> videocam </span>
      <h3>Kamera</h3>
    </div>

    <div class="devices">
      {#each $broadcaster.videoDevices as videoDevice}
        <button
          on:click={() => onCamSelected(videoDevice)}
          disabled={!$broadcaster.videoCanPlay}
          class:active={$broadcaster.selectedVideoDevice?.deviceId === videoDevice.deviceId}
          >{videoDevice.label}</button
        >
      {/each}
    </div>
    <div class="label">
      <span class="material-icons"> mic </span>
      <h3>Mikrofon</h3>
    </div>
    <div class="devices">
      {#each $broadcaster.audioDevices as audioDevice}
        <button
          on:click={() => onMicSelected(audioDevice)}
          disabled={!$broadcaster.videoCanPlay}
          class:active={$broadcaster.selectedAudioDevice?.deviceId === audioDevice.deviceId}
          >{audioDevice.label}</button
        >
      {/each}
    </div>
  </div>
</div>

<style src="./mediaDevices.scss"></style>
